import React, { useState } from "react";
import { Box, ListItem, Stack, Typography } from "@mui/material";
import i18n from "../../i18n-config";
import { CustomButton, CustomLoader, CustomPopper, SvgContainer } from "../../components";
import theme from "../../theme/theme";
import { ADD, LIST } from "../../assets/icons";
import TransactionTable from "./component/TransactionTable";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../store/state";
import { TRANSACTION_EXPORT } from "../../utils/constants";
import { exportAsyncTransaction } from "../../store/features/transactionSlice";

function Transaction() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);

  const transactions = useSelector((state: RootState) =>
    Object.values(state.transaction)
  );

  const handleShowOpen = () => {
    setShow((prev) => !prev);
  };

  const toggleLoader = () => {
    setLoading(!loading);
  };

  const callback = (resBlob: any) => {
    const url = window.URL.createObjectURL(new Blob([resBlob]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `listeTransactions.xlsx`);
    // 3. Append to html page
    document.body.appendChild(link);
    // 4. Force download
    link.click();
    // 5. Clean up and remove the link
    link.parentNode?.removeChild(link);
    setLoading(false);
  };

  const onSelectExport = (item: string) => {
    toggleLoader();
    handleShowOpen();
    dispatch(exportAsyncTransaction(item, callback) as any);
  };

  const onOpenForm = () => {
    navigate("/transactions/add");
  };

  const onDetail = (item: any) => {
    navigate("/transactions/detail/" + item.id);
  };

  return (
    <Box sx={{ height: "100vh", backgroundColor: "#F9F9F9" }} p={3} pt={6}>
      <Stack direction={"row"} justifyContent="space-between" mb={3}>
        <Typography fontSize={22} fontWeight="600">
          {i18n.t("list_transactions")}
        </Typography>
        <Stack direction={"row"} spacing={2}>
          <CustomButton
            title={i18n.t("nouvelle_transaction")}
            leftComponent={
              <SvgContainer svg={ADD} color={theme.colors.white} width={15} />
            }
            titleStyle={{ marginLeft: 1 }}
            onClick={onOpenForm}
          />

          <CustomPopper
            onClose={handleShowOpen}
            icon={
              <CustomButton
                title={i18n.t("exporter_liste")}
                leftComponent={
                  <SvgContainer
                    svg={LIST}
                    color={theme.colors.white}
                    width={15}
                  />
                }
                titleStyle={{ marginLeft: 1 }}
                rootStyle={{ backgroundColor: "#3D423F", height: 45 }}
              />
            }
            containerStyle={{ padding: 0, borderRadius: "5px" }}
            buttonStyle={{
              backgroundColor: "transparent",
              width: "100%",
              padding: 0,
            }}
          >
            <Box
              p={2}
              sx={{
                height: "200px",
                width: "300px",
                position: "relative",
                overflow: "auto",
              }}
            >
              {TRANSACTION_EXPORT.map((val) => (
                <ListItem key={val} sx={{cursor: "pointer"}} onClick={() => onSelectExport(val)} divider>
                  {i18n.t(val)}
                </ListItem>
              ))}
            </Box>
          </CustomPopper>
        </Stack>
      </Stack>
      <TransactionTable data={transactions} onDetail={onDetail} />
      <CustomLoader open={loading} handleClose={toggleLoader} />
    </Box>
  );
}

export default Transaction;
